"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubmitSuccess = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _concernFormContext = require("../../contexts/concernFormContext");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
} // istanbul ignore next -- not testable
const DownloadButton = /*#__PURE__*/ (0, _react.lazy)(async ()=>({
        default: (await Promise.resolve().then(()=>_interopRequireWildcard(require('../DownloadButton')))).DownloadButton
    }));
const SubmitSuccess = ()=>{
    const { concernFormConfig } = (0, _concernFormContext.useConcernForm)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SUBMIT_SUCCESS_MESSAGE),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.IconContainer, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.InfoCircle, {
                    fontSize: "inherit",
                    color: "success"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "h3",
                        component: "h3",
                        color: "textPrimary",
                        children: translations.successfullySent
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                        color: "textPrimary",
                        children: translations.yourConcernWasSuccessfullySent
                    }),
                    // istanbul ignore next -- not testable
                    concernFormConfig.enabledPdfDownload ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DownloadButton, {}) : null
                ]
            })
        ]
    });
};
exports.SubmitSuccess = SubmitSuccess;
